<template>
    <div class="about">
        <div class="box box-aboutme">
            <img src="@/assets/img/avatar.jpeg" />
            <h1>Toni Michael Sattler</h1>
            <div v-html="bioText"></div>
        </div>
        <div class="box box-more">
            <h1>Weiterbildung</h1>
            <div v-html="weiterbildungText"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'About',
        data: function() {
            return {
                bioText: "",
                weiterbildungText: "",
            }
        },
        mounted: function() {
            this.$root.$on('texts-changed', (texts) => {
                this.$data.bioText = texts[0].bio;
                this.$data.weiterbildungText = texts[0].weiterbildung;
            });
        },
    };
</script>

<style lang="less">
    .about {
        display: grid;
        grid-template-columns: 1fr 2fr;
        grid-gap: 20px;
        padding: 50px 0px;
        padding-top: 25px;
        max-width: 1200px;
        margin: 0 auto;
        padding-top: 95px;

        & .box {
            background: #fff;
            box-shadow: 0px 2px 20px rgba(0,0,0,0.15);
            border-radius: 6px;
            padding: 25px;

            &.box-aboutme {
                display: flex;
                flex-direction: column;
                position: relative;

                & img {
                    width: 180px;
                    height: 180px;
                    border-radius: 50%;
                    display: block;
                    position: relative;
                    align-self: center;
                    margin-bottom: 20px;
                    margin-top: -70px;
                    z-index: 2;
                }
            }
            & h1 {
                margin: 0;
                margin-bottom: 10px;
            }
            & p {
                margin-top: 5px;
                line-height: 1.5;
                color: rgba(0,0,0,0.6);

                & strong {
                    color: #000;
                    font-weight: 600;
                }
            }
        }
    }

    @media screen and (max-width: 1250px) {
        .about {
            grid-template-columns: 1fr 2fr;
            width: 95vw;
        }
    }

    @media screen and (max-width: 1000px) {
        .about {
            grid-template-columns: 1fr 1fr;
        }
    }

    @media screen and (max-width: 800px) {
        .about {
            grid-template-columns: 1fr;
        }
    }
</style>
